import React from "react";
import { useEffect } from "react";
import SideBar from "../components/sideBar/sideBar";
import Chat from "../components/scrollDiv/chat";
import SettingPanel from "../components/settingPanel";
import { useSelector, useDispatch } from "react-redux";
import { setWindow } from "../redux/windowSlice";
import { setModelPanel } from "../redux/modelPanelSlice";
import { setSideBar } from "../redux/sideBarSlice";

const Home = () => {
  const conversationId = useSelector((state) => state.conversationId);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkWindowSize = () => {
      if (window.innerWidth <= 700) {
        dispatch(setWindow("small"));
        dispatch(setSideBar("hidden"));
        dispatch(setModelPanel("hidden-bottom"));
      } else if (window.innerWidth <= 1100) {
        dispatch(setSideBar("hidden"));
        dispatch(setModelPanel("right"));
      } else {
        dispatch(setWindow("large"));
        dispatch(setSideBar("left-sidebar"));
        dispatch(setModelPanel("right"));
      }
    };
    checkWindowSize();
    window.addEventListener("resize", checkWindowSize);
    return () => {
      window.removeEventListener("resize", checkWindowSize);
    };
  }, [dispatch, conversationId]);
  // this is for hiding the overlay when clicking a title in the sidebar

  return (
    <div className="flex flex-nowrap h-[calc(100dvh)]   overflow-x-auto overflow-y-hidden relative z-10">
      <SideBar />
      <Chat />
      <SettingPanel />
    </div>
  );
};

export default Home;
